import { render, staticRenderFns } from "./LoansPending.vue?vue&type=template&id=555cda40"
import script from "./LoansPending.vue?vue&type=script&lang=js"
export * from "./LoansPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports